import { ApiService } from '../api.service';
import { Injectable } from '@angular/core';
import { LoginService } from '../services/auth.service';

@Injectable()
export class MessageService {

  messages: any;

  constructor(public api: ApiService, public loginService: LoginService) {}

  fetchMessages(id: number) {
    return this.api.getuserChatByRequestId(id).subscribe(
      r => {
        this.messages = r.userRideHistoryVO;
      },
      error => {
        this.messages = null;
        console.log(error);
      }
    );
  }

  sendMessage(id, message) {
    if (message !== '') {
      const data = {
        rideRequestId: id,
        userRideHistoryVO: [
          {
            comment: message,
            idp: this.loginService.getuser_id(),
            name: this.loginService.getName()
          }
        ]
      };
      this.api.addUserRequestChat(data).subscribe(
        r => {
          message = '';
          this.messages = r.userRideHistoryVO;
        },
        error => {
          console.log(error);
        }
      );
    } else {
      console.log('Please add some text');
    }
  }
}
